import * as React from 'react';
import { FC } from 'react';

const Spinner: FC = () => (
  <span className="input-spinner">
    <i className="rs-icon-spinner rs-icon__spin" />
  </span>
);

export default Spinner;
